/** @jsxImportSource theme-ui */

import { BepiCategory } from 'client/dto';
import { BdScoreBar } from 'components/_common/BdScoreBar';
import { BepiCategoryDescriptions } from 'models/BepiModels';
import React from 'react';
import BepiTooltip from './BepiTooltip';

type BepiScoreBarProps = {
  category: BepiCategory;
  value: number;
};

const BepiScoreBar: React.FC<BepiScoreBarProps> = ({ category, value }) => {
  return value ? (
    <div sx={{ display: 'flex', marginBottom: '24px', alignItems: 'center' }}>
      <BdScoreBar label={BepiCategoryDescriptions[category]?.label} score={value * 100} />
      <div data-html2canvas-ignore="true" sx={{ ml: '12px' }}>
        <BepiTooltip bepiCategoryDescription={BepiCategoryDescriptions[category]} />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default BepiScoreBar;
